import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import "./Blog.css";

const AllCommentsPage = () => {
  const { blogId } = useParams(); // Correct param name
  const [comments, setComments] = useState([]);

  useEffect(() => {
    fetch(`http://localhost:5000/api/comments/${blogId}`)
      .then((res) => res.json())
      .then((data) => setComments(Array.isArray(data) ? data : []))
      .catch((err) => console.error("Error fetching all comments:", err));
  }, [blogId]);

  return (
    <div className="blog-comment-hbt-all-wrapper">
      <h2 className="blog-comment-hbt-title">
        <MessageCircle size={16} style={{ marginRight: "6px" }} />
        All Comments ({comments.length})
      </h2>
      <ul className="blog-comment-hbt-list">
        {comments.map((comment, index) => (
          <li key={index} className="blog-comment-hbt-comment">
            <strong className="blog-comment-hbt-author">{comment.author}</strong>
            <span className="blog-comment-hbt-date">
              {new Date(comment.createdAt).toLocaleString()}
            </span>
            <p className="blog-comment-hbt-content">{comment.content}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AllCommentsPage;
